import { render } from "./FloatingMenu.vue?vue&type=template&id=25cffb61"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"

import "./FloatingMenu.vue?vue&type=style&index=0&id=25cffb61&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__